// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IForfeitureSummaryRecordDto } from './IForfeitureSummaryRecordDto';
import {
    IForfeitureSummaryRecordDtoFromJSON,
    IForfeitureSummaryRecordDtoFromJSONTyped,
    IForfeitureSummaryRecordDtoToJSON,
    IForfeitureSummaryRecordDtoToJSONTyped,
} from './IForfeitureSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoForfeitureSummaryRecordDto
 */
export interface IReportSummaryGroupDtoForfeitureSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoForfeitureSummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<IForfeitureSummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoForfeitureSummaryRecordDto
     */
    subsidiary_records?: Array<IForfeitureSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoForfeitureSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoForfeitureSummaryRecordDto(value: object): value is IReportSummaryGroupDtoForfeitureSummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoForfeitureSummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoForfeitureSummaryRecordDto {
    return IReportSummaryGroupDtoForfeitureSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoForfeitureSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoForfeitureSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(IForfeitureSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoForfeitureSummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoForfeitureSummaryRecordDto {
    return IReportSummaryGroupDtoForfeitureSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoForfeitureSummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoForfeitureSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(IForfeitureSummaryRecordDtoToJSON)),
    };
}

